module.exports = __webpack_public_path__ + "img/white-footer-3.f84fdd41.png";